import React from 'react';
import { asyncComponent } from 'react-async-component';
import Loading from '../../asyncComps/Loading';

export default asyncComponent({
    resolve: () => import('./Analyze'),
    LoadingComponent: ()=>{
        return (
            <Loading ecId={`${this && this.props && this.props.ecId || ''}_Loading@4q29hz`} />
        )
    }
});


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/analyze/AnalyzeAsync.js